<template>
  <div class="row">
    <div class="col-md-12">
      <div class="box box-primary">
        <div class="overlay" v-if="loadingStatsComites">
          <i class="fa fa-refresh fa-spin"></i>
        </div>
        <div class="box-header with-border">
          <h3 class="box-title">Statistiques générales pour les comités</h3>
          <!--<button class="btn btn-default btn-xs pull-right"-->
          <!--@click.prevent="getStatsComites(true)">-->
          <!--<i class="fa fa-refresh "></i>-->
          <!--</button>-->
        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-lg-3 col-md-4 col-sm-6"
                 v-for="province in getProvinces" :key="province.id">
              <div class="stats-province-card">
                <h4 class="stats-province-title"><i class="fa fa-map-marker"></i> {{ province.province }}</h4>
                <div class="stats-province-year" v-for="annee in getAnnees().reverse()" :key="province.id + '-' + annee">
                  <div class="stats-year-label">{{ annee }}</div>
                  <div class="stats-year-links">
                    <a href="#" @click.prevent="getStatsPDF(province,annee)" class="stats-link" v-b-tooltip.hover title="Statistiques ADEPS au format PDF"><i class="fa fa-file-pdf-o"></i> ADEPS</a>
                    <a href="#" @click.prevent="getStatsPDFArena(province,annee)" class="stats-link" v-b-tooltip.hover title="Statistiques ARENA au format PDF"><i class="fa fa-file-pdf-o"></i> ARENA</a>
                    <a href="#" @click.prevent="getStatsExcel(province,annee)" class="stats-link" v-b-tooltip.hover title="Statistiques ADEPS au format Excel"><i class="fa fa-file-excel-o"></i> Excel</a>
                    <a href="#" @click.prevent="getListingClubPDF(province,annee)" class="stats-link" v-b-tooltip.hover title="Listing des clubs"><i class="fa fa-list"></i> Clubs <span class="stats-link-count">{{ getNombreClub(province.id, annee) }}</span></a>
                    <a href="#" @click.prevent="getDiffAnnees(province,annee)" class="stats-link" v-b-tooltip.hover :title="'Différences entre ' + (annee - 1) + ' et ' + annee"><i class="fa fa-exchange"></i> Diff. {{ annee-1 }}/{{ annee }}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {mapGetters, mapActions} from 'vuex'

var _ = require('underscore')
var moment = require('moment')
var FileSaver = require('file-saver');
export default {
  data() {
    return {
      statsComites: null,
      loadingStatsComites: false,
      provinces: []
    }
  },
  props: {},
  computed: {
    ...mapGetters({
      getRoute: 'getRoute',
      getProvinces: 'getProvinces',
    }),

  },
  mounted: function () {
    this.loadProvinces()
    this.getStatsClub()
  },
  methods: {
    ...mapActions({
      setRecap: 'setRecap',
      setProvinces: 'setProvinces',
    }),
    orderedByYear: function (obj) {
      return _.sortBy(obj, 'annee').reverse()
    },
    getNombreClub: function (province, annee) {
      var anneeFound = _.find(this.statsClubs, function (item) {
        return item.annee == annee;
      })
      return anneeFound && anneeFound.nombre[province] ? anneeFound.nombre[province] : 0
    },
    getAnnees: function () {
      let retour = [];
      for (let i = 2007; i <= moment().year(); i++) {
        retour.push(i)
      }
      return retour;
    },
    getStatsPDF: function (province, annee) {
      if (!province || !annee)
        return;
      let self = this;
      this.loadingStatsComites = true
      this.$http.post
      (
        self.getRoute('Statistiques.StatsGeneralesForProvinces'),
        JSON.stringify({
          annee: annee,
          id_prov: province.id
        }),
        {responseType: 'blob'}
      ).then((response) => {
        this.loadingStatsComites = false
        var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
        FileSaver.saveAs(blob, province.province + "_" + annee + "_statistiquesADEPS.pdf");
        return response.blob();
      }, (response) => {
        self.$noty.error("Erreur dans la génération du fichier PDF")
        this.loadingStatsComites = false
      });
    },
     getStatsPDFArena: function (province, annee) {
      if (!province || !annee)
        return;
      let self = this;
      this.loadingStatsComites = true
      this.$http.post
      (
        self.getRoute('Statistiques.StatsGeneralesArenaForProvinces'),
        JSON.stringify({
          annee: annee,
          id_prov: province.id
        }),
        {responseType: 'blob'}
      ).then((response) => {
        this.loadingStatsComites = false
        var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
        FileSaver.saveAs(blob, province.province + "_" + annee + "_statistiquesARENA.pdf");
        return response.blob();
      }, (response) => {
        self.$noty.error("Erreur dans la génération du fichier PDF")
        this.loadingStatsComites = false
      });
    },
    getStatsExcel: function (province, annee) {
      if (!province || !annee)
        return;
      let self = this;
      this.loadingStatsComites = true
      this.$http.post
      (
        self.getRoute('Statistiques.StatsGeneralesForProvincesADEPSExcel'),
        JSON.stringify({
          annee: annee,
          id_prov: province.id
        }),
        // {responseType: 'blob'}
      ).then((response) => {
        // this.loadingStatsComites = false
        // var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
        // FileSaver.saveAs(blob, "ListingExcelAdeps_" + annee + "_" + province.id + ".xls");
        // return response.blob();
      }, (response) => {
        // self.$noty.error("Erreur dans la génération du fichier XLS")
        // this.loadingStatsComites = false
      });
      setTimeout(() => {
        self.$noty.success("Le fichier demandé vous sera envoyé par mail dés qu'il sera généré.")
        this.loadingStatsComites = false
      },2000)
    },
    getListingClubPDF: function (province, annee) {
      if (!province || !annee)
        return;
      let self = this;
      this.loadingStatsComites = true
      this.$http.post
      (
        self.getRoute('Statistiques.exportStatsAdepsListingClubForProvinces'),
        JSON.stringify({
          annee: annee,
          id_prov: province.id
        }),
        {responseType: 'blob'}
      ).then((response) => {
        this.loadingStatsComites = false
        var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
        FileSaver.saveAs(blob, province.province + "_" + annee + "_listing_clubs_ADEPS.pdf");
        return response.blob();
      }, (response) => {
        self.$noty.error("Erreur dans la génération du fichier PDF")
        this.loadingStatsComites = false
      });
    },
    getDiffAnnees: function (province, annee) {
      if (!province || !annee)
        return;
      let self = this;
      this.loadingStatsComites = true
      this.$http.post
      (
        self.getRoute('Statistiques.exportStatsDifferencesForProvinces'),
        JSON.stringify({
          annee: annee,
          id_prov: province.id
        }),
        {responseType: 'blob'}
      ).then((response) => {
        this.loadingStatsComites = false
        var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
        FileSaver.saveAs(blob, province.province + "_" + annee + "_comparaison.pdf");
        return response.blob();
      }, (response) => {
        self.$noty.error("Erreur dans la génération du fichier PDF")
        this.loadingStatsComites = false
      });
    },
    getStatsClub: function (force = false) {
      let self = this;
      this.loadingStatsClubs = true
      self.$http.post(this.getRoute('Statistiques.statistiquesGeneralesClubs'), {forceCache: force}).then((response) => {
        this.statsClubs = response.body
        this.loadingStatsClubs = false

      }, (response) => {
      });
    },
    loadProvinces: function () {
      this.$http.get(this.getRoute('getAllProvinces')).then((response) => {
        this.setProvinces(response.body)
      }, (response) => {
      });
    },
  },
  beforeRouteUpdate(to, from, next) {
  },

  beforeRouteEnter(to, from, next) {
  },
  watch: {},
  components: {}
}
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Statistiques/General/General_comites.vue